import { Color, Font, Spacing, Text, dateToNow, shortLocalizedDateAndTime } from 'zens-storybook'
import React, { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { useStore } from 'zens-store'

import RefreshButton from './button'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  value: {
    color: Color.graphiteGrey,
    fontFamily: Font.regular,
  },
  label: {
    color: Color.metalGrey,
  },
  button: {
    marginLeft: Spacing.XS,
  },
})

interface Props extends ViewProps {
  date?: number
  onRefresh?: () => void
  loading?: boolean
}
const RefreshInfo = (props: Props) => {
  const { date, onRefresh, loading, style, ...otherProps } = props
  const [now, setNow] = useState(new Date())
  const { t } = useTranslation()
  const { i18n } = useStore()

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date())
    }, 60000)
    return () => clearInterval(interval)
  }, [])

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text level={7} style={styles.value}>
        <Text style={styles.label} level={7}>
          <Trans>Last update:</Trans>
        </Text>{' '}
        {shortLocalizedDateAndTime(date || now, i18n.language, t)} (
        {t('{{time}} ago', { time: dateToNow(date || now, i18n.language) })})
      </Text>
      {onRefresh && <RefreshButton onPress={onRefresh} style={styles.button} loading={loading} />}
    </View>
  )
}

export default RefreshInfo
